import { RegisterClass } from "core/Misc/typeStore";
import { RewardGraphNode } from "../rewardGraphNode";
import { RewardGraphConnectionPointTypes } from "../rewardGraphConnectionPointTypes";
import { RewardGraphConnectionPoint } from "../rewardGraphConnectionPoint";
import { RewardGraphBuildState } from "../rewardGraphBuildState";
import { Color3 } from "core/Maths/math.color";
/**
 * Block used to apply a cross product between 2 vectors
 */
export class RewardDrawVectorBlock extends RewardGraphNode {
    /**
     * @param name defines the block name
     */
    public constructor(name: string) {
        super(name);

        this.registerInput("pos", RewardGraphConnectionPointTypes.Vector3);
        this.registerInput("vector", RewardGraphConnectionPointTypes.Vector3);
        this.registerOutput("output", RewardGraphConnectionPointTypes.Vector3);
    }

    /**
     * Gets the current class name
     * @returns the class name
     */
    public override getClassName() {
        return "RewardDrawVectorBlock";
    }

    public get output(): RewardGraphConnectionPoint {
        return this._outputs[0];
    }

    public get pos(): RewardGraphConnectionPoint {
        return this._inputs[0];
    }

    public get vector(): RewardGraphConnectionPoint {
        return this._inputs[1];
    }

    protected override _buildBlock() {
        if (!this.pos.isConnected || !this.vector.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }

        this.output._storedFunction = (state : RewardGraphBuildState) => {
            state.queryContext?.displayDebugVector( this.pos.getConnectedValue(state), this.vector.getConnectedValue(state), Color3.Red() );
            return this.vector.getConnectedValue(state);
        };
    }
}

RegisterClass("MELS.RewardDrawVectorBlock", RewardDrawVectorBlock);
